// src/components/Inputs/TextboxInput.jsx

'use client';

import { useState, useEffect, memo, useRef } from 'react';
import { TextField, FormControl, FormLabel, InputAdornment } from '@mui/material';
import { useFilters } from '@/contexts/Filters.context';


const TextboxInput = ({ legend, label, type, icon, filterName }) => {
  const { getFilterValue, updateFilterValue, hasFilter } = useFilters();
  const [inputValue, setInputValue] = useState(getFilterValue(filterName) || '');
  const debounceTimer = useRef(null);

  // Update the input value when the filter value changes
  useEffect(() => {
    setInputValue(getFilterValue(filterName) || '');
  }, [getFilterValue, filterName]);

  const handleChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    // Clear any existing timeouts
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Debounce the update to the filter context
    debounceTimer.current = setTimeout(() => {
      if (value.trim()) {
        updateFilterValue(filterName, value);
      } else {
        updateFilterValue(filterName, '');
      }
      debounceTimer.current = null;
    }, 300);
  };

  // Clean up timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  const labelStyle = {
    color: hasFilter(filterName) ? '#1976D2' : '',
  };

  return (
    <FormControl component="fieldset" sx={{ width: '100%' }}>
      <FormLabel component="legend" style={labelStyle}>
        {icon}
        {legend}
      </FormLabel>
      <TextField
        label={label}
        type={type}
        value={inputValue}
        onChange={handleChange}
        fullWidth
        variant="outlined"
        size="small"
      />
    </FormControl>
  );
};

export default memo(TextboxInput);
